<template>
  <div class="modal">
    <div class="modal-wrap" v-click-outside="closeModel">
      <ModalInfo
        @emailError="emailError"
        @otherKits="showModel"
        @sendProp="sendProp"
        @editData="editData"
        ref="componentA"
        :show="modelKits"
        :showEdit="showEdit"
      ></ModalInfo>
      <ModalDesc
        v-show="modelKits === false"
        :emailErrorObj="emailErrorObj"
        :personalData="personalData"
        @enableEdit="enableEdit"
        @closeModal="closeModal"
        @showComment="showComment"
        :validationError="validationError"
      ></ModalDesc>
      <transition>
        <ModalKits
          v-if="modelKits === true"
          @closeModal="closeModal"
          @changeDescModal="changeDescModal"
        ></ModalKits>
      </transition>
      <CommentOnHold
        v-if="showCommentModal"
        @closeConfurmHoldTxt="closeConfurmHoldTxt"
        :txtOnHold="txtOnHold"
      ></CommentOnHold>
      <CommentArchive
        v-if="showCommentModal"
        @closeConfurmArchiveTxt="closeConfurmArchiveTxt"
        :txtOnHold="txtOnHold"
      ></CommentArchive>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ModalInfo from "./ModalInfo";
import ModalDesc from "./ModalDesc";
import ModalKits from "./ModalKits";
import CommentOnHold from "./CommentOnHold";

export default {
  name: "Modal",
  data() {
    return {
      modelKits: false,
      showCommentModal: false,
      emailErrorObj: {},
      txtOnHold: "",
      personalData: {
        firstName: "",
        lastName: "",
        email: ""
      },
      validationError: false,
      showEdit:false
    };
  },
  components: {
    ModalInfo,
    ModalDesc,
    ModalKits,
    CommentOnHold
  },
  methods: {
    ...mapActions(["clearInfo"]),
    closeModel() {
      this.clearInfo();
      this.$emit("closeModal", false);
    },
    async validateAndSave() {
      this.validationError = !(await this.$refs.componentA.validate());
    },
    enableEdit(obj){
      this.showEdit = obj
    },
    emailError(error) {
      this.emailErrorObj = error;
    },
    showComment(obj) {
      this.showCommentModal = obj.show;
      this.txtOnHold = obj;
    },
    showModel(boolean) {
      this.modelKits = boolean;
    },
    closeModal(boolean) {
      this.$emit("closeModal", boolean);
    },
    changeDescModal(boolean) {
      this.modelKits = boolean;
    },
    closeConfurmHoldTxt(boolean) {
      this.showCommentModal = boolean;
    },
    sendProp(data) {
      this.personalData = data;
    },
    editData(data) {
      this.personalData = data;
    },
  },
  created() {
    this.personalData.firstName = this.$store.getters.getTestKitInfo.collected_first_name;
    this.personalData.lastName = this.$store.getters.getTestKitInfo.collected_last_name;
    this.personalData.email = this.$store.getters.getTestKitInfo.collected_email;
  }
};
</script>

<style scoped>
.modal {
  width: 100%;
  height: 100%;
  background-color: rgba(219, 230, 241, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-wrap {
  border-radius: 10px;
  height: 750px;
  min-width: 1350px;
  display: flex;
}
@media (max-height: 790px) {
  .modal-wrap {
    height: 690px;
  }
}
</style>
